import { render, staticRenderFns } from "./MoscowCreditBankBlockIcons.vue?vue&type=template&id=72f76bd2&"
import script from "./MoscowCreditBankBlockIcons.vue?vue&type=script&lang=js&"
export * from "./MoscowCreditBankBlockIcons.vue?vue&type=script&lang=js&"
import style0 from "./MoscowCreditBankBlockIcons.vue?vue&type=style&index=0&module=true&lang=postcss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports